import React from "react"
const getNewObj = (arr, type) => {
  const tempObj =
    type === "link"
      ? {
          type: "link",
          linkText: "",
          linkUrl: "",
        }
      : {
          type: "text",
          text: "",
        }

  arr.push(tempObj)

  return tempObj
}
const checkLink = (char,obj,flagObject)=>{
  if (char === "(") {
    flagObject.isLinkText = true
    flagObject.isLinkUrl = false
  } else if (char === ")" || char === "[") {
    flagObject.isLinkText = false
    flagObject.isLinkUrl = true
  } else if (char === "]") {
    flagObject.isLinkText = false
    flagObject.isLinkUrl = false
  } else {
    if (flagObject.isLinkText) {
      obj.linkText += char
    } else if (flagObject.isLinkUrl) {
      obj.linkUrl += char
    } else {
      obj.text += char
    }
  }
  return flagObject;
}
const getEmbeddedLinkObjects = formattedText => {
  const arr = []
  let obj = null

  let flagObject = {};
  flagObject.isLinkText = false;
  flagObject.isLinkUrl = false;
  let prevType = ""
  for (let i = 0; i < formattedText.length; i++) {
    const char = formattedText.charAt(i)
    const prevChar = i > 0 ? formattedText.charAt(i - 1) : null

    if (prevChar === "]" || (i === 0 && char !== "(")) {
      obj = getNewObj(arr, "text")
    } else if (prevChar === "(") {
      obj = getNewObj(arr, "link")
    }

    if (char === " " && prevType === "text") {
      obj = getNewObj(arr, prevType)
      continue
    }
    prevType = obj.type
    flagObject = checkLink(char,obj,flagObject)
  }
  return arr
}

const EmbeddedLink = ({
  text
}) => {
  return (
    <div
    style={{display:'inline-block',overflow:'hidden'}}
    >
      {getEmbeddedLinkObjects(text).map((s, ind) =>
        s.type === "text" ? (
          <a key={ind} style={ind == 0 ? { marginLeft: "1px" } : { marginLeft: "0px" }}>
            {s.text?.replace(/\s/g, "\u00A0")}{" "}
          </a>
        ) : (
          <a
            href={s.linkUrl}
            key={ind}
            style={{
              display: "inline-flex",
              color: "#0d6efd",
              pointerEvents:'none'
            }}
          >
            {s.linkText?.replace(/\s/g, "\u00A0")}
          </a>
        ),
      )}
    </div>
  )
}

export { EmbeddedLink, getEmbeddedLinkObjects }
